module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "header"
    }
  }, [_c('header', {
    staticClass: "header",
    class: [
      [_vm.state], {
        'header--fixed': _vm.isHomepage
      }
    ]
  }, [_c('div', {
    staticClass: "header__wrapper"
  }, [_c('div', {
    staticClass: "header__column"
  }, [_c('logo', {
    attrs: {
      "mode": _vm.isLogoInverted ? 'white' : 'black'
    }
  }), _c('transition', {
    attrs: {
      "name": "page-name",
      "mode": "out-in"
    }
  }, [(!_vm.isLoading && !_vm.isHomepage && !_vm.isPopupOpened && _vm.pageName && _vm.isMobile) ? _c('div', {
    key: _vm.$route.path + '_' + _vm.$route.name,
    staticClass: "page-name",
    class: {
      'is-inverted': _vm.isLogoInverted
    }
  }, [_c('div', {
    staticClass: "page-name__sep"
  }), _c('div', {
    staticClass: "page-name__label"
  }, [_vm._v(_vm._s(_vm.pageName))])]) : _vm._e()])], 1), _c('div', {
    staticClass: "header__column",
    class: {
      'is-inverted': _vm.isMenuInverted
    }
  }, [_c('lang-switcher'), _c('burger')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12f409d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/the-header.vue
// module id = 467
// module chunks = 0